import React from 'react';
import { Box, Tooltip, Stack } from '@mui/material';

type LeadStatus = 'active' | 'warning' | 'critical';

interface LeadStatusIndicatorProps {
  status: LeadStatus;
}

const getStatusConfig = (status: LeadStatus) => {
  switch (status) {
    case 'active':
      return {
        color: 'success.main',
        label: 'Lead Ativo - Com interação recente'
      };
    case 'warning':
      return {
        color: 'warning.main',
        label: 'Lead em Alerta - Sem interação há 15 dias'
      };
    case 'critical':
      return {
        color: 'error.main',
        label: 'Lead Crítico - Sem interação há 30 dias'
      };
  }
};

const LeadStatusIndicator: React.FC<LeadStatusIndicatorProps> = ({ status }) => {
  const config = getStatusConfig(status);

  const getCircleOpacity = (circleStatus: LeadStatus) => {
    if (status === 'active' && circleStatus === 'active') return 1;
    if (status === 'warning' && circleStatus === 'warning') return 1;
    if (status === 'critical' && circleStatus === 'critical') return 1;
    return 0.2;
  };

  return (
    <Tooltip title={config.label} arrow placement="right">
      <Stack 
        direction="row" 
        spacing={0.5} 
        sx={{ 
          display: 'inline-flex',
          ml: 1,
          verticalAlign: 'middle'
        }}
      >
        <Box
          component="span"
          sx={{
            display: 'inline-block',
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: 'success.main',
            opacity: getCircleOpacity('active')
          }}
        />
        <Box
          component="span"
          sx={{
            display: 'inline-block',
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: 'warning.main',
            opacity: getCircleOpacity('warning')
          }}
        />
        <Box
          component="span"
          sx={{
            display: 'inline-block',
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: 'error.main',
            opacity: getCircleOpacity('critical')
          }}
        />
      </Stack>
    </Tooltip>
  );
};

export default LeadStatusIndicator; 